import CategoryList from './CategoryList'
import { withCategoryList } from './withCategoryList'

const ConnectedCategoryList = withCategoryList(CategoryList)

export { ConnectedCategoryList as CategoryList }
